<template>
    <div class="body_client_detail">
        <div v-if="isLoading && !counterpart" class="state_message">
            <p>Cargando detalle…</p>
        </div>

        <div v-else-if="error" class="state_message">
            <p class="error_text">{{ error }}</p>
        </div>

        <template v-else>
            <GeneralInfoCard class="card_block"
                :counterpart="counterpart"
                :total-range="totalRange"
                :documents-count="documentsCount"
                :range-label="rangeLabel"
                :first-active-month="firstActiveMonth" />

            <MonthlyHistoryCard class="card_block"
                :series="monthlyHistory" />

            <DocumentsDetailCard class="card_block"
                :filtered-documents="filteredDocuments"
                :counterpart="counterpartForCards"
                :search="search"
                :categories="categoryTypes"
                @update-search="onSearchUpdate" />
        </template>
    </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";

import GeneralInfoCard from "./GeneralInfoCard.vue";
import MonthlyHistoryCard from "./MonthlyHistoryCard.vue";
import DocumentsDetailCard from "./DocumentsDetailCard.vue";

export default {
    name: "BodyClientDetail",

    components: { GeneralInfoCard, MonthlyHistoryCard, DocumentsDetailCard },

    // ModalFullHeightRight pasa `bodyProps: null` — la body lee directo del
    // store. El header sí recibe payload (alias/rut/pills) porque es
    // presentational puro.
    props: {
        payload: { type: Object, default: null },
    },

    computed: {
        ...mapState("clientDetail", [
            "counterpart",
            "documents",
            "monthlyHistory",
            "isLoading",
            "error",
            "search",
            "monthIso",
            "totalRange",
        ]),
        ...mapGetters("clientDetail", [
            "filteredDocuments",
            "documentsCount",
            "firstActiveMonth",
            "rangeLabel",
        ]),
        ...mapState("classification", { categoryTypes: "categories" }),

        // DocumentsDetailCard usa ci_id/pay_or_charge/obligation_name del
        // counterpart pero también necesita acceso al store. El shape que
        // recibimos del backend ya tiene esos campos, así que lo pasamos
        // tal cual.
        counterpartForCards() {
            return this.counterpart;
        },
    },

    methods: {
        ...mapMutations("clientDetail", { setSearch: "SET_SEARCH" }),

        onSearchUpdate(value) {
            this.setSearch(value);
        },
    },
};
</script>

<style scoped lang="scss">
// El body ocupa al menos el 100% de la altura disponible del modal y, si el
// contenido excede esa altura, el scroll vertical aparece acá. Los cards
// (incluyendo el de documentos) toman su altura natural — la tabla muestra
// todas sus filas sin scroll interno.
.body_client_detail {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    gap: 16px;
    overflow-y: auto;
}

.card_block {
    flex-shrink: 0;
}

.state_message {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 24px 16px;
    text-align: center;
    color: var(--report-text-muted);
    font-size: 14px;
}

.error_text {
    color: var(--report-negative);
}
</style>
